import React, { FC } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from 'components/Header';
import { GlobalProvider } from 'context/GlobalProvider';
import { CountryProvider } from 'context/CountryProvider';
import { MessageProvider } from 'context/MessageContext';
import { WaiterListLayout } from 'components/layouts/WaiterListLayout';
import { PaymentLayout } from 'components/layouts/PaymentLayout';
import { SuccessLayout } from 'components/layouts/SuccessLayout';
import { FailLayout } from 'components/layouts/FailLayout';
import { CookiePopup } from 'components/CookiePopup';
import { LandingRedirect } from 'components/LandingRedirect';
import { ERoute } from 'common/const';

export const App: FC = () => {
  return (
    <div className="app">
      <div className="container">
        {/* Страна над шапкой и попапом: они рисуются до ответа бэка и на всех экранах (US-034, R-3) */}
        <CountryProvider>
          <Header />

          <MessageProvider>
            <GlobalProvider>
              <Routes>
                <Route path={ERoute.WaiterList} element={<WaiterListLayout />} />
                <Route path={ERoute.Payment} element={<PaymentLayout />} />
                <Route path={ERoute.Success} element={<SuccessLayout />} />
                <Route path={ERoute.Fail} element={<FailLayout />} />
                {/* Корень и неизвестный путь - на лендинг, своего экрана нет (pay-host R-2) */}
                <Route path="*" element={<LandingRedirect />} />
              </Routes>
            </GlobalProvider>
          </MessageProvider>

          <CookiePopup />
        </CountryProvider>
      </div>
    </div>
  );
};
